<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Table'
  }
</script>
